<template>
  <div v-if="shouldDisplay" class="sf-label sf-bg-white">
    <span class="sf-text sf-c-text sf-bold">{{ currentIndex + 1 }}</span>
    <span class="sf-text sf-c-text-light">{{ ` / ${total}` }}</span>
  </div>
</template>

<script>
export default {
  props: {
    currentIndex: {
      type: Number,
    },
    total: {
      type: Number,
    },
    showEmpty: {
      type: Boolean,
    },
  },
  computed: {
    shouldDisplay() {
      return this.total > 0 || this.showEmpty
    },
  },
}
</script>
